const getMerchantName = () => window.location.pathname.split('/')[1];

export default getMerchantName;
